import { jsx } from 'react/jsx-runtime';
import { CodeSnippet } from '@backstage/core-components';

const PlainApiDefinitionWidget = (props) => {
  return /* @__PURE__ */ jsx(
    CodeSnippet,
    {
      text: props.definition,
      language: props.language,
      showCopyCodeButton: true
    }
  );
};

export { PlainApiDefinitionWidget };
//# sourceMappingURL=PlainApiDefinitionWidget.esm.js.map
